import { dataLayerTracking } from "@/libs/gtmTracking";

export const GACartIconClickedEvent = ({ deviceType, contentType = "", contentTitle = "" }) => {
  dataLayerTracking({
    event: "add_to_cart",
    device_type: deviceType,
    content_type: contentType,
    content_title: contentTitle,
  });
};
